var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-modal', {
    attrs: {
      "id": _vm.modalId,
      "title": _vm.$t('event-flow.import.title'),
      "size": "lg",
      "close-disabled": _vm.importing
    },
    on: {
      "on-hidden": _vm.reset
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [!_vm.importResult ? _c('div', {
          staticClass: "file-upload"
        }, [_c('label', {
          attrs: {
            "for": "event-flow-import-file"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.import.file-label')) + " ")]), _c('div', {
          staticClass: "file-picker-row"
        }, [_c('input', {
          ref: "fileInput",
          staticClass: "d-none",
          attrs: {
            "id": "event-flow-import-file",
            "type": "file",
            "accept": _vm.excelFileAccept
          },
          on: {
            "change": _vm.onFileSelected
          }
        }), _c('div', {
          staticClass: "selected-file-name",
          attrs: {
            "aria-live": "polite"
          }
        }, [_vm._v(" " + _vm._s(_vm.selectedFileName) + " ")]), _c('b-button', {
          staticClass: "browse-button",
          attrs: {
            "type": "button",
            "variant": "primary",
            "disabled": _vm.isBusy
          },
          on: {
            "click": _vm.openFilePicker
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.import.browse')) + " ")])], 1), _c('b-button', {
          staticClass: "download-template-button",
          attrs: {
            "type": "button",
            "variant": "link",
            "disabled": _vm.isBusy,
            "aria-busy": _vm.downloadingTemplate
          },
          on: {
            "click": _vm.downloadTemplate
          }
        }, [_vm.downloadingTemplate ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('event-flow.import.download-template')) + " ")], 1)], 1) : _vm._e(), !_vm.importResult ? _c('div', {
          staticClass: "modal-actions"
        }, [_c('b-button', {
          attrs: {
            "type": "button",
            "variant": "outline-primary",
            "disabled": _vm.isBusy
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('back')) + " ")]), _c('b-button', {
          attrs: {
            "type": "button",
            "variant": "primary",
            "disabled": !_vm.selectedFile || _vm.isBusy,
            "aria-busy": _vm.importing
          },
          on: {
            "click": _vm.onImport
          }
        }, [_vm.importing ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(_vm.importing ? 'event-flow.import.uploading' : 'event-flow.import.submit')) + " ")], 1)], 1) : _c('div', {
          staticClass: "import-result",
          attrs: {
            "aria-live": "polite"
          }
        }, [_c('p', {
          staticClass: "import-result-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.import.complete')) + " ")]), _vm.failedRowsMessage ? _c('p', {
          staticClass: "import-result-errors"
        }, [_vm._v(" " + _vm._s(_vm.failedRowsMessage) + " ")]) : _vm._e(), _c('b-button', {
          staticClass: "result-button",
          attrs: {
            "type": "button",
            "variant": "primary"
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.import.ok')) + " ")])], 1)];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }